import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const put = (id,limit) =>
  requestsTemplates.put(mainPath, `/vacation_limits/${id}`,limit);
